import { QrcodeInfo, QrCodePractice } from "config/routersConstants";

export const QrCodeMenuList = [
    {title:"Scan for Personal Health Record", icon:"", path:QrcodeInfo.path,  target:"_blank", key: 1},
    {title:"Scan for Patient Virtual Check In", icon:"", path:QrCodePractice.path, key: 2},
]